/* SPOOKY CART — recently viewed products (local storage + product JSON) */
(function () {
  'use strict';
  const KEY = 'spooky:recent';
  const LIMIT = 12;
  const S = window.Spooky || (window.Spooky = {});

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, LIMIT))); } catch (e) { /* noop */ }
  };

  function record(handle) {
    if (!handle) return;
    const list = read().filter((h) => h !== handle);
    list.unshift(handle);
    write(list);
  }
  S.recordRecentlyViewed = record;

  function card(product) {
    const img = product.featured_image
      ? '<img src="' + product.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') + '" alt="' +
        String(product.title).replace(/"/g, '&quot;') + '" loading="lazy" width="300" height="300">'
      : '<span class="skeleton" style="position:absolute;inset:0"></span>';
    const onSale = product.compare_at_price && product.compare_at_price > product.price;

    // The .carousel__slide wrapper is what gives every card the same width.
    // .carousel__viewport is a flex row, so a bare .card lands in it as a
    // flex item with the default min-width:auto / flex:0 1 auto and sizes
    // itself from its own content - which is why the cards used to come out
    // uneven. The slide class carries the fixed, breakpoint-aware width and
    // the scroll-snap alignment that the other carousels already rely on.
    return (
      '<div class="carousel__slide">' +
      '<a class="card" href="' + product.url + '">' +
      '<span class="card__media media media--square">' + img + '</span>' +
      '<span class="card__body">' +
      '<span class="card__title">' + product.title + '</span>' +
      '<span class="price' + (onSale ? ' price--on-sale' : '') + '">' +
      '<span class="price__current">' + S.formatMoney(product.price) + '</span>' +
      (onSale ? '<s class="price__compare">' + S.formatMoney(product.compare_at_price) + '</s>' : '') +
      '</span></span></a>' +
      '</div>'
    );
  }

  async function render(container) {
    const exclude = container.getAttribute('data-exclude') || '';
    const max = Number(container.getAttribute('data-limit') || 4);
    const handles = read().filter((h) => h !== exclude).slice(0, max);
    if (!handles.length) { container.closest('[data-recently-viewed-section]')?.setAttribute('hidden', ''); return; }

    const products = [];
    for (const handle of handles) {
      try {
        const res = await fetch(S.routes.root.replace(/\/$/, '') + '/products/' + handle + '.js');
        if (res.ok) products.push(await res.json());
      } catch (e) { /* skip missing product */ }
    }
    if (!products.length) { container.closest('[data-recently-viewed-section]')?.setAttribute('hidden', ''); return; }
    container.innerHTML = products.map(card).join('');
    container.closest('[data-recently-viewed-section]')?.removeAttribute('hidden');
  }

  document.addEventListener('DOMContentLoaded', () => {
    const current = document.querySelector('[data-current-product-handle]');
    if (current) record(current.getAttribute('data-current-product-handle'));
    document.querySelectorAll('[data-recently-viewed]').forEach(render);
  });
})();
